import { useLang } from "@/lib/i18n";
import { Link } from "react-router-dom";

const SECTIONS = [
  {
    eyebrow: "Legal Entity",
    lines: [
      { strong: true, text: "JUKE TRANSFERS j.d.o.o." },
      { text: "Passenger transport services by car with a driver upon request" },
      { muted: true, text: "Activity Code: H49330" },
      { text: "Director & Representative: Ivan Jukica" },
    ],
  },
  {
    eyebrow: "Identification & Registration",
    lines: [
      { text: "OIB (Tax ID): 05308456115" },
      { text: "MBS (Company Reg No): 060515900" },
      { text: "Date of Incorporation: 29.05.2026" },
    ],
  },
  {
    eyebrow: "Official Bank Account",
    lines: [
      { strong: true, text: "ERSTE & STEIERMÄRKISCHE BANK D.D." },
      { text: "IBAN: HR8124020061101346755" },
    ],
  },
];

export default function Footer() {
  const { t, lang } = useLang();
  const isHr = lang === "hr";
  const termsPath = isHr ? "/hr/terms" : "/terms";
  const refundPath = isHr ? "/hr/refund-policy" : "/refund-policy";
  const privacyPath = isHr ? "/hr/privacy" : "/privacy";
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#050505] pt-16 pb-10 px-6 lg:px-10">
      <div className="max-w-6xl mx-auto text-center">
        <div className="flex items-center justify-center gap-2 mb-12">
          <span className="font-display text-2xl text-white">Juke</span>
          <span className="font-display text-2xl text-[#C5A059] italic">Transfers</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12 max-w-5xl mx-auto">
          {SECTIONS.map((s) => (
            <div key={s.eyebrow} data-testid={`footer-section-${s.eyebrow.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <p className="text-[10px] uppercase tracking-[0.3em] text-[#C5A059] mb-4">{s.eyebrow}</p>
              <div className="space-y-1.5">
                {s.lines.map((l, i) => (
                  <p
                    key={i}
                    className={
                      l.strong
                        ? "text-sm text-white font-medium tracking-wide"
                        : l.muted
                        ? "text-xs text-zinc-600"
                        : "text-sm text-zinc-400 leading-relaxed"
                    }
                  >
                    {l.text}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-white/5 flex flex-col items-center gap-4">
          <nav
            data-testid="footer-legal-nav"
            aria-label="Legal"
            className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[11px] uppercase tracking-[0.25em] text-zinc-500"
          >
            <Link
              to={termsPath}
              data-testid="footer-terms-link"
              className="hover:text-[#C5A059] transition-colors"
            >
              {isHr ? "Uvjeti poslovanja" : "Terms & Conditions"}
            </Link>
            <span aria-hidden className="text-zinc-800">·</span>
            <Link
              to={refundPath}
              data-testid="footer-refund-link"
              className="hover:text-[#C5A059] transition-colors"
            >
              {isHr ? "Pravilnik o povratu" : "Refund Policy"}
            </Link>
            <span aria-hidden className="text-zinc-800">·</span>
            <Link
              to={privacyPath}
              data-testid="footer-privacy-link"
              className="hover:text-[#C5A059] transition-colors"
            >
              {isHr ? "Politika privatnosti" : "Privacy Policy"}
            </Link>
            <span aria-hidden className="text-zinc-800">·</span>
            <Link
              to="/partners"
              data-testid="footer-partners-link"
              className="hover:text-[#C5A059] transition-colors"
            >
              {isHr ? "Postani partner" : "Partner with Us"}
            </Link>
            <span aria-hidden className="text-zinc-800">·</span>
            <Link
              to="/postani-vozac"
              data-testid="footer-driver-link"
              className="hover:text-[#C5A059] transition-colors"
            >
              {isHr ? "Postani vozač" : "Become a Driver"}
            </Link>
            <span aria-hidden className="text-zinc-800">·</span>
            <Link
              to="/b2b"
              data-testid="footer-b2b-link"
              className="hover:text-[#C5A059] transition-colors"
            >
              {isHr ? "Za hotele i agencije" : "Hotels & Agencies"}
            </Link>
          </nav>

          <p className="text-xs uppercase tracking-[0.25em] text-zinc-500">
            © 2026 JUKE TRANSFERS j.d.o.o. All rights reserved.
          </p>
          <a
            href="/price-list-juke-transfers.pdf"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-price-list-link"
            className="text-xs text-zinc-400 hover:text-amber-400 underline mt-4 block text-center"
          >
            📄 Official Reference Price List (NN 101/2026)
          </a>
          <a
            href="/admin"
            data-testid="footer-admin-link"
            className="text-[10px] uppercase tracking-[0.3em] text-zinc-700 hover:text-[#C5A059] transition-colors"
          >
            {t("footer.admin")}
          </a>
        </div>
      </div>
    </footer>
  );
}
